import { useState } from 'react';

export type ArtistBioProps = {
  bio: string;
  maxLengthInShort: number;
};

const ArtistBio = (props: ArtistBioProps) => {
  const { bio, maxLengthInShort } = props;
  const [readMore, setReadMore] = useState(false);

  if (bio.length == 0) {
    return null;
  }

  if (bio.length < maxLengthInShort) {
    return <p className="text-b2 font-normal text-gray-100">{bio}</p>;
  }

  if (readMore) {
    return <p className="text-b2 font-normal text-gray-100">{bio}</p>;
  }

  return (
    <div>
      <p className="text-b2 font-normal text-gray-100">
        {bio.slice(0, maxLengthInShort)}...
      </p>
      <button onClick={() => setReadMore(true)}>
        <p className={`text-h5 font-bold text-gray-300`}>Read more..</p>
      </button>
    </div>
  );
};

export default ArtistBio;
